module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "browserTips"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5db795e1","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/browserTips/browserTips.vue
// module id = 1234
// module chunks = 2